module.exports = "<p>\r\n  icons works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/icons/icons.component.html
// module id = ./src/app/icons/icons.component.html
// module chunks = main